import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const r = e((h, m) => /* @__PURE__ */ s.jsx(
  a,
  {
    ref: m,
    ...h,
    image: (l) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...l,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4179",
              width: 32,
              height: 22,
              x: 8,
              y: 13,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M26.41 13H8v22h32V13zm0 1.179h10.988L26.41 21.643zm-4.82 0v7.464l-11.47-7.464zm-12.433.883 10.698 6.974H9.157zm0 11.884h9.445l-9.349 6.286v-6.286zm12.433 6.777H10.602l10.12-6.875h.868zm4.82 0v-6.875h.963l10.506 6.875zm12.433-.785-9.156-5.992h9.156zm0-7.268h-13.59v8.053h-2.41V25.67H9.157v-2.456h13.686V14.18h2.41v9.035h13.59zm0-3.634H27.952l10.891-7.268z"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4179)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0-.247h48v48.911H0z" }) })
        ]
      }
    )
  }
));
r.displayName = "AgencyFlagUkIcon";
export {
  r as AgencyFlagUkIcon,
  r as default
};
//# sourceMappingURL=index.js.map
